/* Local dependencies */
import { Order } from "../../../shared/types";
import { ListOrdersActionTypes, ListOrdersError, ListOrdersRequest, ListOrdersSuccess, ResetListOrdersError, ResetListOrdersState } from "./types";

export function listOrders(options): ListOrdersRequest {
  const { query, filter, from, size, currentPage } = options;
  
  return {
    type: ListOrdersActionTypes.LIST_ORDERS_REQUEST,
    query,
    filter,
    from,
    size,
    currentPage,
  };
}

export function listOrdersSuccess(total: number, orders: Order[]): ListOrdersSuccess {
  return {
    type: ListOrdersActionTypes.LIST_ORDERS_SUCCESS,
    orders,
    total,
  };
}

export function listOrdersError(error: Error): ListOrdersError {
  return {
    type: ListOrdersActionTypes.LIST_ORDERS_ERROR,
    error,
  };
}

export function resetListOrdersError(): ResetListOrdersError {
  return {
    type: ListOrdersActionTypes.RESET_ERROR,
  };
}

export function resetListOrdersState(): ResetListOrdersState {
  return {
    type: ListOrdersActionTypes.RESET_STATE,
  };
}

